export const ASK_REMOVE = 'Remove post?';
export const CONFIRM_REMOVE = 'Are you sure?';
export const NOTIFY_REMOVE = 'Removed!';
